<template>
  <div class="null-container">

  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.null-container{
    width: 100%;
    height: 100%;
    background-image: url('~@/assets/img/gnjsz.png');
    background-repeat: no-repeat;
    background-position: center;
}
</style>